import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

const KEY = "suffle_cookie_consent_v1";

export default function CookieBanner() {
  const [show, setShow] = useState(false);
  useEffect(() => { try { if (!localStorage.getItem(KEY)) setShow(true); } catch { /* ignore */ } }, []);
  const decide = (v) => { try { localStorage.setItem(KEY, v); } catch { /* ignore */ } setShow(false); };
  if (!show) return null;
  return (
    <div data-testid="cookie-banner" className="fixed inset-x-0 bottom-0 z-[60] border-t border-slate-200 bg-white/95 backdrop-blur">
      <div className="mx-auto flex max-w-5xl flex-col gap-3 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
        <p className="flex items-start gap-2 text-xs text-slate-600 sm:items-center">
          <Cookie className="mt-0.5 h-4 w-4 shrink-0 text-amber-500 sm:mt-0" />
          <span>We use essential cookies to keep you signed in and to secure checkout, and optional cookies for personalization. See our{" "}
            <Link to="/legal/privacy-policy" className="font-medium text-blue-600 hover:underline">Privacy Policy</Link> and{" "}
            <Link to="/legal/cookie-policy" className="font-medium text-blue-600 hover:underline">Cookie Policy</Link>.</span>
        </p>
        <div className="flex shrink-0 gap-2">
          <button onClick={() => decide("essential")} data-testid="cookie-essential" className="rounded-full border border-slate-200 px-4 py-1.5 text-xs font-semibold text-slate-600 hover:bg-slate-50">Essential only</button>
          <button onClick={() => decide("all")} data-testid="cookie-accept" className="rounded-full brand-gradient-bg px-4 py-1.5 text-xs font-semibold text-white">Accept all</button>
        </div>
      </div>
    </div>
  );
}
